import { useMutation } from '@apollo/client';

import { CreatePlaceInput } from '../../apollo/__generated__/graphql';
import { PLACES } from '../../place/graphql/query/placesQuery.graphql';
import { CREATE_PLACE } from '../graphql/mutation/createPlaceMutation.graphql';

export const useCreatePlaceMutation = (
  onCompleted: (placeId: string) => void,
) => {
  const [mutate] = useMutation(CREATE_PLACE, {
    onCompleted: ({ createPlace: { id } }) => onCompleted(id),
  });

  const createPlace = (createPlaceInput: CreatePlaceInput) => {
    mutate({
      variables: {
        createPlaceInput,
      },
      refetchQueries: [PLACES],
    });
  };

  return { createPlace };
};
